/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOriginDestinationRate.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/origin-destination-rate";

export class AutogenModelOriginDestinationRate<RowType extends ModelRow> extends Endpoint<RowType, RowOriginDestinationRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOriginDestinationRate extends ModelRow<RowOriginDestinationRateFields> {
	constructor(values?: Partial<RowOriginDestinationRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOriginDestinationRateFields {
	bill_distance: number;
	bill_distance_um: string;
	company_id: string;
	descr: string;
	dest_city_name: string;
	dest_city_no: number;
	dest_code: string;
	dest_state: string;
	dest_value: string;
	dest_zip: string;
	id: string;
	intermediate_city_name: string;
	intermediate_city_no: number;
	intermediate_code: string;
	intermediate_state: string;
	intermediate_value: string;
	intermediate_zip: string;
	last_used_date: Date;
	minimum_charge: number;
	minimum_charge_c: string;
	minimum_charge_d: Date;
	minimum_charge_n: number;
	minimum_charge_r: number;
	orig_city_name: string;
	orig_city_no: number;
	orig_code: string;
	orig_state: string;
	orig_value: string;
	orig_zip: string;
	pt_to_pt: string;
	rate: string;
	rate_id: number;
	rate_type: string;
	times_used: number;
	transit_time: number;
	unit_descr: string;
}

